import {
  getAddresses,
  updateAddressType,
  deleteAddress,
  postAddress,
  putAddress,
  updateReturnCarrier,
} from "@utils/call-api/addresses-call";

export const TYPES = {
  SET_ADDRESSES: "SET_ADDRESSES",
  SET_ADDRESSES_LOADING: "SET_ADDRESSES_LOADING",
};

function setAddressesLoading(isLoading) {
  return {
    type: TYPES.SET_ADDRESSES_LOADING,
    isLoading,
  };
}

function setAddresses(addresses) {
  return {
    type: TYPES.SET_ADDRESSES,
    addresses,
  };
}

export async function getAddressesAction(dispatch) {
  dispatch(setAddressesLoading(true));

  const res = await getAddresses();
  dispatch(setAddresses(res));
  dispatch(setAddressesLoading(false));
}

export function reloadUserAddresses() {
  return async (dispatch) => {
    dispatch(setAddressesLoading(true));

    const res = await getAddresses();
    dispatch(setAddresses(res));
    dispatch(setAddressesLoading(false));
  };
}

export function updateAddressTypeAction(id, data, addressType) {
  return async (dispatch) => {
    const res = await updateAddressType(id, data);

    setTimeout(() => {
      dispatch(reloadUserAddresses());
    }, 3000);

    dispatch({
      type: TYPES.SET_ADDRESSES,
      addresses: res,
      addressType,
    });
  };
}

export function deleteAddressAction(addressId) {
  return async (dispatch) => {
    const res = await deleteAddress(addressId);

    dispatch({
      type: TYPES.SET_ADDRESSES,
      addresses: res,
    });
  };
}

export function addAddressAction(address, addressType) {
  return async (dispatch) => {
    const res = await postAddress(address);

    setTimeout(() => {
      dispatch(reloadUserAddresses());
    }, 3000);

    dispatch({
      type: TYPES.SET_ADDRESSES,
      addresses: res,
      addressType,
    });
  };
}

export function updateAddressAction(id, address) {
  return async (dispatch) => {
    const res = await putAddress(id, address);

    setTimeout(() => {
      dispatch(reloadUserAddresses());
    }, 3000);

    dispatch({
      type: TYPES.SET_ADDRESSES,
      addresses: res,
    });
  };
}

export function updateReturnCarrierAction(carrierName) {
  return async (dispatch) => {
    const res = await updateReturnCarrier(carrierName);

    setTimeout(() => {
      dispatch(reloadUserAddresses());
    }, 3000);

    dispatch({
      type: TYPES.SET_ADDRESSES,
      addresses: res,
    });
  };
}
